export interface PainPoint {
  title: string
  description: string
}

export const painPoints: PainPoint[] = [
  {
    title: 'Toujours repartir de zéro',
    description: 'Vous cherchez des idées, des supports et des consignes qui forment une vraie séance.',
  },
  {
    title: 'Des niveaux très différents',
    description: 'Vous avez besoin de points d’entrée et de variantes pour faire participer vos élèves.',
  },
  {
    title: 'Peu de temps ou de matériel',
    description:
      'Un imprévu, une salle différente, des instruments indisponibles\u00A0: il vous faut des options concrètes.',
  },
]
